exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i[data-v-51b08aa9]{font-size:10px}", ""]);

// exports
